const translations = {
  // Navigation
  'nav.home': { en: 'Home', th: 'หน้าแรก' },
  'nav.about': { en: 'About', th: 'เกี่ยวกับเรา' },
  'nav.services': { en: 'Services', th: 'บริการ' },
  'nav.portfolio': { en: 'Portfolio', th: 'ผลงาน' },
  'nav.contact': { en: 'Contact Us', th: 'ติดต่อเรา' },

  // Hero
  'hero.subtitle': { en: 'Creative Technology Company', th: 'บริษัทเทคโนโลยีสร้างสรรค์' },
  'hero.cta': { en: 'Contact Us', th: 'ติดต่อเรา' },
  'hero.viewWork': { en: 'View Our Work', th: 'ดูผลงานของเรา' },
  'hero.yearsExp': { en: 'Years Experience', th: 'ปีประสบการณ์' },
  'hero.projects': { en: 'Successful Projects', th: 'โปรเจกต์สำเร็จ' },
  'hero.clients': { en: 'Clients', th: 'ลูกค้า' },

  // About
  'about.label': { en: 'WHAT WE DO?', th: 'เราทำอะไร?' },
  'about.cat1': { en: 'Web & Virtual', th: 'เว็บไซต์ & เสมือนจริง' },
  'about.cat1desc': { en: 'Web Application and Virtual Tour 360° design services. Seamlessly connect your business to the online world.', th: 'บริการออกแบบเว็บแอปพลิเคชันและ Virtual Tour 360° เชื่อมต่อธุรกิจของคุณสู่โลกออนไลน์อย่างไร้รอยต่อ' },
  'about.cat2': { en: 'On-Ground Interactive', th: 'อินเทอร์แอคทีฟ' },
  'about.cat2desc': { en: 'Interactive system services for event venues including Projection Mapping, Games, AR/VR, and sensor-based activations.', th: 'บริการระบบอินเทอร์แอคทีฟสำหรับสถานที่จัดงาน ทั้ง Projection Mapping, เกม, AR/VR และระบบเซนเซอร์' },
  'about.cat3': { en: 'Custom Tech & AI', th: 'เทคโนโลยี & AI' },
  'about.cat3desc': { en: 'Custom-made Hardware, Sensor, and AI Software development with powerful backend management systems.', th: 'พัฒนา Hardware, Sensor และซอฟต์แวร์ AI สั่งทำพิเศษ พร้อมระบบจัดการหลังบ้านอันทรงพลัง' },

  // Services
  'services.label': { en: 'Our Services', th: 'บริการของเรา' },
  'services.title': { en: 'What We Offer', th: 'สิ่งที่เรานำเสนอ' },
  'services.subtitle': { en: 'End-to-end creative technology solutions tailored to elevate your brand and engage your audience.', th: 'โซลูชันเทคโนโลยีสร้างสรรค์ครบวงจร ออกแบบมาเพื่อยกระดับแบรนด์และสร้างการมีส่วนร่วมกับผู้ชมของคุณ' },

  // Portfolio
  'portfolio.label': { en: 'Portfolio', th: 'ผลงาน' },
  'portfolio.title': { en: 'Our Work', th: 'ผลงานของเรา' },
  'portfolio.subtitle': { en: 'Explore our latest projects spanning web, interactive installations, and innovative technology solutions.', th: 'สำรวจโปรเจกต์ล่าสุดของเรา ครอบคลุมเว็บไซต์ ระบบอินเทอร์แอคทีฟ และโซลูชันเทคโนโลยีนวัตกรรม' },
  'portfolio.all': { en: 'All', th: 'ทั้งหมด' },
  'portfolio.loadMore': { en: 'Load More', th: 'ดูเพิ่มเติม' },
  'portfolio.empty': { en: 'No projects found for this period.', th: 'ไม่พบโปรเจกต์ในช่วงเวลานี้' },

  // Contact
  'contact.label': { en: 'Get In Touch', th: 'ติดต่อเรา' },
  'contact.title': { en: 'Contact Us', th: 'ติดต่อเรา' },
  'contact.subtitle': { en: 'Have a project in mind? We would love to hear from you.', th: 'มีโปรเจกต์ในใจ? เรายินดีรับฟังจากคุณ' },
  'contact.together': { en: "Let's Work Together", th: 'มาร่วมงานกัน' },
  'contact.togetherDesc': { en: 'Whether you need a website, interactive installation, virtual experience, or custom technology solution — we are here to help bring your vision to life.', th: 'ไม่ว่าคุณต้องการเว็บไซต์ ระบบอินเทอร์แอคทีฟ ประสบการณ์เสมือนจริง หรือโซลูชันเทคโนโลยีสั่งทำ — เราพร้อมช่วยให้วิสัยทัศน์ของคุณเป็นจริง' },
  'contact.address': { en: 'Address', th: 'ที่อยู่' },
  'contact.phone': { en: 'Phone', th: 'โทรศัพท์' },
  'contact.email': { en: 'Email', th: 'อีเมล' },
  'contact.hours': { en: 'Business Hours', th: 'เวลาทำการ' },

  // Contact Form
  'form.name': { en: 'Full Name *', th: 'ชื่อ-นามสกุล *' },
  'form.namePh': { en: 'John Doe', th: 'กรอกชื่อ-นามสกุล' },
  'form.email': { en: 'Email Address *', th: 'อีเมล *' },
  'form.emailPh': { en: 'john@example.com', th: 'กรอกอีเมล' },
  'form.phone': { en: 'Phone Number', th: 'เบอร์โทรศัพท์' },
  'form.phonePh': { en: '+66 xxx xxx xxxx', th: '+66 xxx xxx xxxx' },
  'form.subject': { en: 'Subject', th: 'หัวข้อ' },
  'form.subjectPh': { en: 'Project inquiry', th: 'สอบถามเกี่ยวกับโปรเจกต์' },
  'form.message': { en: 'Message *', th: 'ข้อความ *' },
  'form.messagePh': { en: 'Tell us about your project...', th: 'บอกเราเกี่ยวกับโปรเจกต์ของคุณ...' },
  'form.send': { en: 'Send Message', th: 'ส่งข้อความ' },
  'form.sending': { en: 'Sending...', th: 'กำลังส่ง...' },
  'form.success': { en: 'Thank you! Your message has been sent successfully.', th: 'ขอบคุณ! ข้อความของคุณถูกส่งเรียบร้อยแล้ว' },
  'form.errName': { en: 'Name is required', th: 'กรุณากรอกชื่อ' },
  'form.errEmail': { en: 'Email is required', th: 'กรุณากรอกอีเมล' },
  'form.errEmailInvalid': { en: 'Please enter a valid email', th: 'กรุณากรอกอีเมลที่ถูกต้อง' },
  'form.errMessage': { en: 'Message is required', th: 'กรุณากรอกข้อความ' },

  // Footer
  'footer.nav': { en: 'Navigation', th: 'เมนู' },
  'footer.contact': { en: 'Contact', th: 'ติดต่อ' },
  'footer.privacy': { en: 'Privacy Policy', th: 'นโยบายความเป็นส่วนตัว' },
  'footer.terms': { en: 'Terms of Service', th: 'ข้อกำหนดการใช้บริการ' },

  // Service Detail
  'sd.loading': { en: 'Loading service...', th: 'กำลังโหลด...' },
  'sd.notFound': { en: 'Service not found', th: 'ไม่พบบริการ' },
  'sd.notFoundDesc': { en: 'The requested service could not be found.', th: 'ไม่พบบริการที่ร้องขอ' },
  'sd.backHome': { en: 'Back to Home', th: 'กลับหน้าแรก' },
  'sd.ourServices': { en: 'OUR SERVICES', th: 'บริการของเรา' },
  'sd.interested': { en: 'Interested in this service?', th: 'สนใจบริการนี้?' },
  'sd.discuss': { en: "Let's discuss how we can bring your vision to life.", th: 'มาพูดคุยกันว่าเราจะทำให้วิสัยทัศน์ของคุณเป็นจริงได้อย่างไร' },

  // Clients
  'clients.label': { en: 'Trusted By', th: 'ไว้วางใจโดย' },
  'clients.title': { en: 'Our Clients', th: 'ลูกค้าของเรา' },

  // 404
  'notFound.title': { en: 'Page Not Found', th: 'ไม่พบหน้าที่ต้องการ' },

  // Cookie
  'cookie.message': { en: 'This website uses cookies to improve your experience. By using this website, you agree to our cookie policy.', th: 'เว็บไซต์นี้ใช้คุกกี้เพื่อพัฒนาประสบการณ์การใช้งาน โดยการใช้เว็บไซต์นี้ถือว่าคุณยินยอมตามนโยบายคุกกี้ของเรา' },
  'cookie.accept': { en: 'Accept', th: 'ยอมรับ' },
  'cookie.decline': { en: 'Decline', th: 'ปฏิเสธ' },
};

export default translations;
